export const rarities = {
  rare: "#4FD875",
  legendary: "#FCC801",
  epic: "#8550F7",
  mythic: "#4FB7D8",
  uncommon: "#2B43C2",
  common: "#9c9c9c",
};
